<ng-template #Modal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate" [nbSpinner]="info.IsLoding">
    <nb-card-header>
      {{ 'common_select' | translate }}{{ 'common_addon_group_title' | translate }}

      <div class="row mx-0 mt-3">
        <input class="col" [(ngModel)]="query.searchKey" name="searchKey" type="text" nbInput fullWidth
          shape="rectangle" [placeholder]="'common_search_addon_group_title' | translate">
        <button class="col-auto ml-2 btn" nbButton (click)="onQuery()">
          <i class="fas fa-search"></i>
        </button>
      </div>

      <div class="d-flex mx-0 mt-2 justify-content-between">
        <button class="col-auto mr-auto btn" nbButton (click)="onSelectAll()">
          {{status.isSelectAll ? ('common_cancel_all' | translate) : ('common_select_all' | translate)}}
        </button>
        <nb-select class="col-auto pr-0" style="width:180px" [(ngModel)]="selectORG_Store_ID" (selectedChange)="onQuery()">
          <nb-option *ngFor="let e of storeSelectList" [value]="e.value">{{ e.content }}</nb-option>
        </nb-select>
        <nb-select class="col-auto pr-0" style="width:100px" [(ngModel)]="status.showType" (selectedChange)="onShowType()">
          <nb-option [value]="0">{{ 'common_all' | translate }}</nb-option>
          <nb-option [value]="1">{{ 'common_selected' | translate }}</nb-option>
          <nb-option [value]="2">{{ 'common_unselected' | translate }}</nb-option>
        </nb-select>
      </div>
    </nb-card-header>

    <nb-card-body>
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th>{{ 'common_select' | translate }}</th>
            <th>{{ 'common_addon_group_title' | translate }}</th>
            <th>{{ 'common_option_content' | translate }}</th>
            <th>{{ 'common_option_type' | translate }}</th>
            <th>{{ 'common_required' | translate }}</th>
            <th>{{ 'common_create_store' | translate }}</th>
          </tr>
        </thead>
        <tbody *ngIf="showList">
          <tr *ngFor="let item of showList; let j = index">
            <td *ngIf="item.isSelect" (click)="onSelect(false,item)">
              <button class="btn btn-info py-0 px-1 checkbtn"><i class="fa fa-check"></i></button>
            </td>
            <td *ngIf="!item.isSelect" (click)="onSelect(true,item)">
              <button class="btn btn-info py-0 px-1 checkbtn"></button>
            </td>
            <td style="vertical-align: middle;">{{item.GroupName}}</td>
            <td style="vertical-align: middle;">{{item.Content}}</td>
            <td style="vertical-align: middle;">{{item.AttachItemKindName}}</td>
            <td style="vertical-align: middle;">{{item.IsRequiredName}}</td>
            <td style="vertical-align: middle;">{{item.CreateStoreName}}</td>
          </tr>
        </tbody>
      </table>
    </nb-card-body>

    <nb-card-footer>
      <button nbButton class="btn btn-info" (click)="onSave()">{{ 'common_confirm' | translate }}</button>
      <button nbButton (click)="ref.close()">{{ 'common_close' | translate }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
